export default [
	{ statusId: 1, color: 'blue', textId: 'report.props.status.inserted' },
	{ statusId: 2, color: 'green', textId: 'report.props.status.new' },
	{ statusId: 3, color: 'red', textId: 'report.props.status.declined' },
	{ statusId: 4, color: 'teal', textId: 'report.props.status.referenced' },
	{ statusId: 5, color: 'grey', textId: 'report.props.status.seen' },
	{
		statusId: 6,
		color: 'light-blue',
		textId: 'report.props.status.inProcess'
	},
	{ statusId: 7, color: 'green', textId: 'report.props.status.completed' },
	{ statusId: 8, color: 'red', textId: 'report.props.status.deleted' }
];



// WEBPACK FOOTER //
// ./constants/ReportStatus.js